import { render } from "./ImagePicker.vue?vue&type=template&id=c55e8f80&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=c55e8f80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c55e8f80"]])

export default __exports__